import './App.css'
import React, { useEffect, useRef, useState } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom' // ✅ Fixed import
import WarrantyHome from './home/WarrantyHome.js'
import Sidebar from './component/Sidebar.js'
import WarrantyRequest from './warrantyRequest/WarrantyRequest.js'
import WarrantyClaim from './Warrantyclaim/Warrantyclaim.jsx'
import ClaimList from './claimList/ClaimList.js'
import Login from './component/Login.jsx'
import { Toaster } from 'react-hot-toast'
import Adduser from './Adduser/Adduser.jsx'
// import { APICall } from "./api/index.js";
import { useNavigate } from 'react-router'
import PrivateRoute from './PrivateRoute.js'
import { handleLogout } from '../src/api/auth.js'
// import ForgotPassword from './component/ForgotPassword.jsx'

function App () {
  const navigate = useNavigate()
  const [selectedWarranty, setSelectedWarranty] = useState(null)
  const [selectedClaim, setSelectedClaim] = useState(null)
  const [showSidebar, setShowSidebar] = useState(false)
  const [createdFromBrand, setCreatedFromBrand] = useState('trackAndTrail')
  const [isPopupVisible, setIsPopupVisible] = useState(false)

  const closeSidebar = () => setShowSidebar(false)
  const handleOverlayClick = React.useCallback(() => closeSidebar(), [])

  const togglePopup = () => {
    // console.log("Toggle Popup Called");
    setIsPopupVisible(prev => !prev)
  }

  const [showAddUser, setShowAddUser] = useState(false)
  const [isPopupShow, setIsPopupShow] = useState(false)

  const handleHideAddUser = () => setShowAddUser(false)
  const handleShowAddUser = () => {
    setShowAddUser(true)
    setShowSidebar(false)
  }

  const togglePopupShow = () => {
    setIsPopupShow(!isPopupShow)
    setShowSidebar(false)
    // console.log("togglePopupShow");
    // console.log("isPopupShow: ", isPopupShow);
    // console.log("isPopupVisible: ", isPopupVisible);
  }

  // const onOkClick = async () => {
  //   const dataLog = await APICall.post(
  //     "https://node-ticycles-warranty.vercel.app/log/logOut",
  //     {
  //       withCredentials: true,
  //     }
  //   );
  //   if (dataLog.data.success) {
  //     localStorage.clear();
  //     sessionStorage.clear();
  //     navigate("/auth");
  //     setIsPopupShow(false);
  //     setShowSidebar(false);
  //   }
  //   if (dataLog.data.error) {
  //     setIsPopupShow(false);
  //     setShowSidebar(false);

  //     // console.log("error", dataLog.data.error);
  //   }
  // };

  const onOkClick = async () => {
    await handleLogout(navigate, setIsPopupShow, setShowSidebar)
  }

  const location = useLocation()
  const allowedSidebarRoutes = ['/', '/claimList', '/claim', '/warrantyReq']
  const hideSidebar = !allowedSidebarRoutes.includes(location.pathname)

  // const hideSidebar = ["/auth"].includes(location.pathname);
  // location.pathname === "/auth" || location.pathname === "/forgotpassword";
  // const hideSidebar =
  //   location.pathname === "/auth" || location.pathname === "/forgotpassword";

  const inactivityTimerRef = useRef(null)

  const resetInactivityTimer = () => {
    if (inactivityTimerRef.current) {
      clearTimeout(inactivityTimerRef.current)
    }
    inactivityTimerRef.current = setTimeout(() => {
      sessionStorage.clear()
      navigate('/auth')
    }, 30 * 60 * 1000) // 30 minutes
  }

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'scroll']

    events.forEach(event =>
      window.addEventListener(event, resetInactivityTimer)
    )

    resetInactivityTimer() // Initialize

    return () => {
      clearTimeout(inactivityTimerRef.current)
      events.forEach(event =>
        window.removeEventListener(event, resetInactivityTimer)
      )
    } // eslint-disable-next-line
  }, [])

  // useEffect(() => {
  //   let inactivityTimer;

  //   const resetTimer = () => {
  //     clearTimeout(inactivityTimer);
  //     inactivityTimer = setTimeout(() => {
  //       sessionStorage.clear();
  //       navigate("/auth");
  //       // }, 30 * 60 * 1000); // 30 minutes
  //     }, 3 * 1000); // 30 minutes
  //     console.log("hhhhhh");
  //   };

  //   // Event listeners for user activity
  //   window.addEventListener("mousemove", resetTimer);
  //   window.addEventListener("keydown", resetTimer);
  //   window.addEventListener("click", resetTimer);
  //   window.addEventListener("scroll", resetTimer);

  //   resetTimer(); // Initialize timer on component mount

  //   return () => {
  //     clearTimeout(inactivityTimer);
  //     window.removeEventListener("mousemove", resetTimer);
  //     window.removeEventListener("keydown", resetTimer);
  //     window.removeEventListener("click", resetTimer);
  //     window.removeEventListener("scroll", resetTimer);
  //   };
  // }, [navigate]);

  return (
    <main className='relative w-screen h-screen p-3 md:p-4 flex bg-background'>
      <Toaster />
      {!hideSidebar && (
        <div className='hidden xl:flex'>
          <Sidebar
            setShowSidebar={setShowSidebar}
            setCreatedFromBrand={setCreatedFromBrand}
            togglePopupShow={togglePopupShow}
            handleShowAddUser={handleShowAddUser}
          />
        </div>
      )}

      {showSidebar && !hideSidebar && (
        <div
          className='fixed inset-0 z-50 bg-black bg-opacity-50 transition-opacity'
          onClick={handleOverlayClick}
        />
      )}

      {isPopupShow && (
        <div className='fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50'>
          <div className='bg-white rounded-lg shadow-lg w-96 p-6'>
            <h2 className='text-xl font-semibold text-gray-800 mb-4'>
              Confirm logout
            </h2>
            <p className='text-gray-600 mb-6'>
              Are you sure you want to log out?
            </p>
            <div className='flex justify-end space-x-4'>
              <button
                onClick={() => togglePopupShow(false)}
                className='px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300'
              >
                Cancel
              </button>
              <button
                onClick={onOkClick}
                className='px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700'
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      <div className='flex flex-col items-center justify-center min-h-screen bg-gray-100'></div>
      {showAddUser && <Adduser onClose={handleHideAddUser} />}

      {isPopupVisible && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start z-10'>
          <Adduser />
          <button
            onClick={togglePopup}
            className=' text-gray-700 hover:text-gray-800 mt-20'
          >
            {showAddUser && <Adduser onClose={handleHideAddUser} />}
          </button>
        </div>
      )}

      <main className='w-full h-full overflow-scroll no-scrollbar'>
        <Routes>
          <Route path='/auth' element={<Login />} />
          <Route element={<PrivateRoute />}>
            <Route
              path='/'
              element={
                <WarrantyHome
                  setSelectedWarranty={setSelectedWarranty}
                  showSidebar={showSidebar}
                  setShowSidebar={setShowSidebar}
                  createdFromBrand={createdFromBrand}
                  setCreatedFromBrand={setCreatedFromBrand}
                  togglePopupShow={togglePopupShow}
                  handleShowAddUser={handleShowAddUser}
                />
              }
            />
            <Route
              path='/claimList'
              element={
                <ClaimList
                  setSelectedClaim={setSelectedClaim}
                  showSidebar={showSidebar}
                  setShowSidebar={setShowSidebar}
                  createdFromBrand={createdFromBrand}
                  setCreatedFromBrand={setCreatedFromBrand}
                  togglePopupShow={togglePopupShow}
                  handleShowAddUser={handleShowAddUser}
                />
              }
            />
            {/* <Route path='/forgotpassword' element={<ForgotPassword />} /> */}
            <Route
              path='/claim'
              element={
                <WarrantyClaim
                  selectedClaim={selectedClaim}
                  createdFromBrand={createdFromBrand}
                />
              }
            />
            <Route
              path='/warrantyReq'
              element={
                <WarrantyRequest
                  selectedWarranty={selectedWarranty}
                  createdFromBrand={createdFromBrand}
                />
              }
            />
          </Route>
        </Routes>
      </main>
    </main>
  )
}

export default App
